import { Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { TeacherjobsService } from '../../serivce/teacherjobs.service';

@Component({
  selector: 'app-delete-teacherjobs-dialog',
  templateUrl: './delete-teacherjobs-dialog.component.html',
  styleUrls: ['./delete-teacherjobs-dialog.component.css']
})
export class DeleteTeacherjobsDialogComponent implements OnInit {
  datas;
  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private router: Router,
    private toastr: ToastrService,
    private service: TeacherjobsService,
    private spinner: NgxSpinnerService
  ) {
    this.datas = data;
  }
  ngOnInit() {
  }
  deleteTeacherJobs() {
    debugger
    var model = {
      Id: this.datas.model.Id
    }
    this.spinner.show();
    this.service.delTeacherJobs(model).subscribe(res => {
      this.spinner.hide();
      if (res.status == 2) {
        this.toastr.success("Xóa phân công công việc thành công", "Thành công");
        this.dialogRef.close();
      }
      else {
        this.toastr.error("Xóa phân công công việc thất bại", "Không hành công");
      }
    })
  }
  onNoClick() {
    this.dialogRef.close();
  }
}
